import type { Component } from "vue";
import type { CountdownStyle } from "@aswin.dev/types";

import MinimalStyle from "./MinimalStyle.vue";
import MatrixStyle from "./MatrixStyle.vue";
import FlipClockStyle from "./FlipClockStyle.vue";
import GlassmorphismStyle from "./GlassmorphismStyle.vue";
import NeonGamingStyle from "./NeonGamingStyle.vue";
import RetroLedStyle from "./RetroLedStyle.vue";
import SciFiHologramStyle from "./SciFiHologramStyle.vue";
import LuxuryGoldStyle from "./LuxuryGoldStyle.vue";
import Floating3dStyle from "./Floating3dStyle.vue";
import LiquidMorphStyle from "./LiquidMorphStyle.vue";
import MinimalDarkSaasStyle from "./MinimalDarkSaasStyle.vue";
import MechanicalCounterStyle from "./MechanicalCounterStyle.vue";
import GradientBlobStyle from "./GradientBlobStyle.vue";
import TerminalCliStyle from "./TerminalCliStyle.vue";
import SpaceGalaxyStyle from "./SpaceGalaxyStyle.vue";
import AnimeCyberpunkStyle from "./AnimeCyberpunkStyle.vue";
import LuxuryWeddingStyle from "./LuxuryWeddingStyle.vue";
import KidsCartoonStyle from "./KidsCartoonStyle.vue";
import IndustrialTechStyle from "./IndustrialTechStyle.vue";
import AiFuturisticStyle from "./AiFuturisticStyle.vue";

export interface CountdownStyleEntry {
  id: CountdownStyle;
  /** Stable English label — translated in the toolbar via i18n. */
  label: string;
  component: Component;
}

export const COUNTDOWN_STYLES: readonly CountdownStyleEntry[] = [
  { id: "minimal", label: "Minimal Modern", component: MinimalStyle },
  { id: "matrix", label: "Matrix Cyberpunk", component: MatrixStyle },
  { id: "flip", label: "Flip Clock", component: FlipClockStyle },
  {
    id: "glassmorphism",
    label: "Glassmorphism",
    component: GlassmorphismStyle,
  },
  { id: "neonGaming", label: "Neon Gaming", component: NeonGamingStyle },
  { id: "retroLed", label: "Retro LED", component: RetroLedStyle },
  {
    id: "scifiHologram",
    label: "Sci-Fi Hologram",
    component: SciFiHologramStyle,
  },
  { id: "luxuryGold", label: "Luxury Gold", component: LuxuryGoldStyle },
  { id: "floating3d", label: "3D Floating", component: Floating3dStyle },
  { id: "liquidMorph", label: "Liquid Morph", component: LiquidMorphStyle },
  {
    id: "minimalDarkSaas",
    label: "Minimal Dark SaaS",
    component: MinimalDarkSaasStyle,
  },
  {
    id: "mechanicalCounter",
    label: "Mechanical Counter",
    component: MechanicalCounterStyle,
  },
  { id: "gradientBlob", label: "Gradient Blob", component: GradientBlobStyle },
  { id: "terminalCli", label: "Terminal CLI", component: TerminalCliStyle },
  { id: "spaceGalaxy", label: "Space Galaxy", component: SpaceGalaxyStyle },
  {
    id: "animeCyberpunk",
    label: "Anime Cyberpunk",
    component: AnimeCyberpunkStyle,
  },
  {
    id: "luxuryWedding",
    label: "Luxury Wedding",
    component: LuxuryWeddingStyle,
  },
  { id: "kidsCartoon", label: "Kids Cartoon", component: KidsCartoonStyle },
  {
    id: "industrialTech",
    label: "Industrial Tech",
    component: IndustrialTechStyle,
  },
  { id: "aiFuturistic", label: "AI Futuristic", component: AiFuturisticStyle },
] as const;

const STYLE_MAP: Record<CountdownStyle, Component> = COUNTDOWN_STYLES.reduce(
  (acc, entry) => {
    acc[entry.id] = entry.component;
    return acc;
  },
  {} as Record<CountdownStyle, Component>,
);

export function resolveCountdownStyleComponent(
  style: CountdownStyle | undefined,
): Component {
  return STYLE_MAP[style ?? "minimal"] ?? MinimalStyle;
}

export { MinimalStyle };
